module.exports = __webpack_public_path__ + "img/Differentiation-GBM_GSE194329.9bd8c1d5.png";